import { z } from 'zod'

import { paginacaoSearchFields, toLimitOffset } from '@/widgets/data-table/table-search'

import type { CostCenterListParams } from './api'

/** Search params da tela de Configurações › Centros de custo. */
export const centrosSearchSchema = z.object({
  ...paginacaoSearchFields,
  q: z.string().min(1).optional(),
  ordenar: z.enum(['name', '-name', 'created_at', '-created_at']).default('name'),
})

export type CentrosSearch = z.infer<typeof centrosSearchSchema>

/** Ordem default do endpoint (cost_center_service._ORDER_BY_DEFAULT). */
export const CENTROS_ORDEM_DEFAULT = 'name' satisfies CentrosSearch['ordenar']

export function toCostCenterListParams(s: CentrosSearch): CostCenterListParams {
  return {
    ...(s.q !== undefined && { search: s.q }),
    order_by: s.ordenar,
    ...toLimitOffset(s),
  }
}
